import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table,
  Spinner,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
//import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import moment from "moment"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as clientAction from "../../../store/bW9udGhXaX/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
//import moment from "moment"
import api from "helpers/Api"
import ReactDOM from 'react-dom'
import MonthWiseTableComponent from "./MonthWiseTableComponent"


import "./styles.scss"
import { MultiSelect } from "react-multi-select-component"

const MonthWiseClientDeliverable = (props) => {
  const { searchBtnStyle, dispatch } = props

  const title = "Month Wise Client Deliverable"

  //Fetching API
  useEffect(() => {
    dispatch(clientAction.loadProductStatus())
    dispatch(clientAction.loadRecordsMetaData())
  }, [])
  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  //date format
  const update = useSelector(
    (specificstate) => specificstate.monthWiseClientDeliverable
  )
  //product_data
  const { recordsMetaData = {}, product_data = []} = update

  //Handle Change
  const [productStatusData, setProductStatusData] = useState({
    eventFromDate: "",
    eventToDate: "",
  })

  const handleChange = (e) => {
    setProductStatusData({
      ...productStatusData,
      [e.target.name]: e.target.value,
    })
  }

  const productCategoryOptions =
    !isEmpty(recordsMetaData) &&
      !isEmpty(recordsMetaData.productCategoryOptions)
      ? recordsMetaData.productCategoryOptions
      : []
  const [productCategory, setProductCategory] = useState([])


  const [downloadLoading, setDownloadLoading] = useState(false)
  //Search value

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)


  const products = !isEmpty(productCategory)
    ? productCategory.map((m) => m.value)
    : ""
  const handleFilter = (e) => {
    e.preventDefault()

    var searchEmployee = !isEmpty(products) && products ? products : ""
    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchEmployee) {
      searchvalue.productCategoryId = searchEmployee
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    // setSearchValue(searchvalue)
    dispatch(clientAction.loadProductStatus(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 3000)
  }

  //reset

  const resetForm = () => {
    setProductCategory([])
    setSearchInput("")
    setProductStatusData({
      ...productStatusData,
      eventFromDate: "",
      eventToDate: "",
    })
    dispatch(clientAction.loadProductStatus())
  }

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      clientAction.loadProductStatus({
        searchFilter: searchInput,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  
  const exportToCsv = () => {
    var searchEmployee = !isEmpty(products) && products ? products : ""
    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchEmployee) {
      searchvalue.productCategoryId = searchEmployee
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
 
    setDownloadLoading(true)

    api
      .post(`/get_production_processStatus_month_wise_report`, searchvalue)
      .then((response) => {
        const productData = response.data.data || []
        const monthsHeader =
          productData.length > 0
            ? productData[0].month.map(
              ({ month, year }) => `${month} - ${year}`
            )
            : []

        const photoExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const statusValues = ["PL PENDING", "CLIENT PENDING", "EW PENDING", "EW QUEUE", "EW INPROGRESS", "EW COMPLETED", "PENDING TO SHARE", "QC RECHECK", "CLIENT REWORK", "CLIENT CHANGES", "ON HOLD","NOT APPLICABLE","SHARED TO CLIENT"]


            const processStatusCounts = data.month.map(({ processStatusCount }) => {

              const counts = {}
              statusValues.forEach(status => {
                counts[status] = processStatusCount[status] || 0
              })

              counts["PENDING TO SHARE"] =
              processStatusCount["EW QC COMPLETED"] || 0

              counts["PL PENDING"] += processStatusCount["PENDING PL"] || 0

              // Create an array of counts based on statusValues order
              const sortedCounts = statusValues.map(status => counts[status])

              return sortedCounts
            })


            return {
              _id: index,
              sNo: index + 1,
              product: data.product,
              status: statusValues.join("\n"),
              monthProcessCounts: processStatusCounts,
            }
          })
          : []

        setTimeout(() => {
          let csvContent = `S.No,Product,Status,${monthsHeader.join(",")}\n`
          const transposedCounts = monthsHeader.map((_, index) =>
            photoExportDataTable.map((row) => row.monthProcessCounts[index])
          )
          photoExportDataTable.forEach((row, rowIndex) => {

            const statusLines = row.status.split("\n")

            // Iterate over status lines
            for (let i = 0; i < statusLines.length; i++) {
              if (i === 0) {
                csvContent += `${row.sNo},${row.product},"${statusLines[i]}"`
              } else {
                // csvContent += ",,," + statusLines[i]
                csvContent += ',,"' + statusLines[i] + '"'
              }

              // Add month process counts for each month
              for (let j = 0; j < monthsHeader.length; j++) {
                csvContent += `,${transposedCounts[j][rowIndex]?.[i] || 0}`
              }

              csvContent += "\n"
            }
          })

          downloadFile({
            data: csvContent,
            fileName: "MonthWiseClientDeliverable.csv",
            fileType: "text/csv",
          })

          setDownloadLoading(false)
        }, 1000)

        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }




  const handleClickTab = (tableData) => {
   
    const statusName = tableData.status
    const date = tableData.date
      let statusDetails = {
      productCategoryId:tableData.productCategoryId,
      productionProcessStatus:tableData.productionProcessStatus,
      month:tableData.month,
      year:tableData.year,
      
    }
   
    if (tableData.status === "EW INPROGRESS") {
      statusDetails.isPending = true
    } else if (tableData.status === "EW QUEUE") {
      statusDetails.isPending = false
    }


    api
    .post(`/get_Production_Deliverable_processStatus_monthwise_details`,statusDetails)
    .then((response) => { 
      const statusData = !isEmpty(response.data.data)?response.data.data:[]
      setTimeout(() => {
        // Use the current value of statusData, which should be updated due to the useEffect
     
        const newTab = window.open("", "_blank", "width=600,height=400")
        if (newTab) {
          const container = newTab.document.createElement("div")
          newTab.document.body.appendChild(container)
          ReactDOM.render(
            <MonthWiseTableComponent
              data={statusData} // Use statusData directly here
              dispatch={dispatch}
                statusPayload={statusDetails}
                name={statusName}
                dateFormat={dateFormat}
                date={date}
            />,
            container
          )
          newTab.document.title = "MONTH-WISE-CLIENT-DELIVERABLE"
        }
      }, 2000)
    })
    .catch((error) => {
      Promise.reject(error)
     
    })
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Product Category"}
                        >
                          {"Product Category"}
                        </Label>
                      </div>

                      <MultiSelect
                        options={productCategoryOptions}
                        value={productCategory}
                        onChange={setProductCategory}
                        labelledBy="Select"
                        hasSelectAll={true}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Event Date"}>
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={productStatusData.eventFromDate}
                        max={productStatusData.eventToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={productStatusData.eventToDate}
                        min={productStatusData.eventFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>

                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>

                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>
                <Row>
                  <Col md="4" lg="4" sm="12"></Col>
                  <Col
                    md="8"
                    lg="8"
                    sm="12"
                    style={{ marginBottom: "20px", marginTop: "-41px" }}
                  >
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <Button
                        className="btn btn-primary"
                        onClick={exportToCsv}
                        id="download"
                        style={{
                          backgroundColor: "#e40d8c",
                          color: "white",
                          border: "none",
                        }}
                      >
                        Download
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Col md="12" lg="12" xl="12" className="mt-3">
                <div style={{ overflowX: "auto" }}>
                  <Table bordered style={{ minWidth: "100%" }}>
                    <thead>
                      <tr>
                      <th style={{minWidth: "50px", position: "sticky", left: 0, zIndex: 1,backgroundColor: "#F8F8FB"}}>S.No</th>
                          <th style={{ minWidth: "190px", position: "sticky", left: "50px", zIndex: 1,backgroundColor: "#F8F8FB"}}>Product Category</th>
                          <th style={{ minWidth: "190px", position: "sticky", left:"240px", zIndex: 1,backgroundColor: "#F8F8FB"}}>Status</th>
                        {!isEmpty(product_data) && product_data.length > 0
                          ? Object.entries(product_data[0].month).map(
                            ([key, value]) => {
                              return (
                                <th
                                  style={{
                                    minWidth: "120px",
                                  }}
                                  key={key}
                                >
                                  {`${value.month} - ${value.year}`}
                                </th>
                              )
                            }
                          )
                          : []}
                      </tr>
                    </thead>
                    <tbody>
                      {product_data &&
                        !isEmpty(product_data) &&
                        product_data.length > 0
                        ? product_data.map((product, index) => {

                          const statusData = ["PL PENDING", "CLIENT PENDING", "EW PENDING", "EW QUEUE", "EW INPROGRESS", "EW COMPLETED", "PENDING TO SHARE", "QC RECHECK", "CLIENT REWORK", "CLIENT CHANGES", "ON HOLD","NOT APPLICABLE","SHARED TO CLIENT"]
                          return (
                            <>
                              <tr key={index}>
                              <td style={{ minWidth: "50px",position: "sticky", left: 0, zIndex: 1,backgroundColor: "#F8F8FB" }}>{index + 1}</td>
                                  <th style={{ minWidth: "190px", position: "sticky", left:"50px", zIndex: 1,backgroundColor: "#F8F8FB" }}>{product.product}</th>
                                <th className="mx-2" style={{ minWidth: "190px",position: "sticky",  left:"240px", zIndex: 1,backgroundColor: "#F8F8FB" }}>
                                  {
                                    statusData.map((status, index, statusesArray) => (
                                      <span
                                        key={index}
                                        className={index !== statusesArray.length - 1 ? "process-status-row" : "process-last-row"}
                                      >
                                        {status}
                                      </span>
                                    ))}

                                </th>
                                {product.month.map((month, monthIndex) => (
                                  <td key={monthIndex} className="text-align-center" style={{ minWidth: "120px" }}>
                                    {statusData.map((status, statusIndex) => {
                                      // Check if status exists in month.processStatusCount, if not, assign 0 to count
                                      let count = month.processStatusCount[status] || 0
                                      if (status === "PENDING TO SHARE") {
                                        count +=
                                          month.processStatusCount[
                                            "EW QC COMPLETED"
                                          ] || 0
                                      }
                                      // If status is "PL PENDING", add count of "PENDING PL" as well
                                      if (status === "PL PENDING") {
                                        count += month.processStatusCount["PENDING PL"] || 0
                                      }
                                      //get process status
                                      const processId = recordsMetaData && !isEmpty(recordsMetaData.deliverOptions) ?
                                      recordsMetaData.deliverOptions.find(m => m.label == status) &&
                                      recordsMetaData.deliverOptions.find(m => m.label == status).processStatusId : ""
                                      //get product category id
                                      const productId = recordsMetaData && !isEmpty(recordsMetaData.productCategoryOptions) ?
                                      recordsMetaData.productCategoryOptions.find(m => m.label == product.product) &&
                                      recordsMetaData.productCategoryOptions.find(m => m.label == product.product).value: ""
                                      const monthName = month.month
                                      const monthValue = monthName === "Jan" ? 1 :
                                        monthName === "Feb" ? 2 : monthName === "Mar" ? 3 : monthName === "Apr" ? 4 : monthName === "May" ? 5 :
                                          monthName === "June" ? 6 : monthName === "July" ? 7 : monthName === "Aug" ? 8 : monthName === "Sep" ? 9 :
                                            monthName === "Oct" ? 10 : monthName === "Nov" ? 11 : monthName === "Dec" ? 12 :
                                              ""  
                                              const ewProcessId =
                                              recordsMetaData &&
                                              !isEmpty(
                                                recordsMetaData.deliverOptions
                                              )
                                                ? recordsMetaData.deliverOptions.find(
                                                    (m) => m.label == "EW QUEUE"
                                                  ) &&
                                                  recordsMetaData.deliverOptions.find(
                                                    (m) => m.label == "EW QUEUE"
                                                  ).processStatusId
                                                : ""

                                              const pendingToShareProcessId =
                                              recordsMetaData &&
                                              !isEmpty(
                                                recordsMetaData.deliverOptions
                                              )
                                                ? recordsMetaData.deliverOptions.find(
                                                    (m) =>
                                                      m.label == "EW QC COMPLETED"
                                                  ) &&
                                                  recordsMetaData.deliverOptions.find(
                                                    (m) =>
                                                      m.label == "EW QC COMPLETED"
                                                  ).processStatusId
                                                : ""
                                      const tableData = {
                                      
                                        status: status, 
                                        productionProcessStatus:
                                            status == "EW INPROGRESS"
                                              ? ewProcessId
                                              : status == "PENDING TO SHARE"
                                              ? pendingToShareProcessId
                                              : processId, // find 
                                        month:monthValue,
                                        year: month.year,
                                        productCategoryId:productId ,
                                        isPending:
                                        status == "EW INPROGRESS"
                                          ? "true"
                                          : status == "EW QUEUE"
                                          ? "false"
                                          : "",
                                      }
                                      return (
                                        <span
                                          key={statusIndex}
                                          className={
                                            statusIndex !== statusData.length - 1
                                              ? "status-row"
                                              : "last-row"
                                          }
                                          onClick={() => handleClickTab(tableData)}
                                        >
                                          {count}
                                        </span>
                                      )
                                    })}
                                  </td>
                                ))}



                              </tr>
                            </>
                          )
                        })
                        : ""}
                    </tbody>
                  </Table>
                  </div>
                  <div className="font-size-14 mt-2">
                    <p>
                      {" "}
                      <p>{`Showing rows ${product_data && product_data.length > 0 ? 1 : 0
                        } to ${product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                        } of ${product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                        }`}</p>
                    </p>
                  </div>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </div>
  )
}
MonthWiseClientDeliverable.propTypes = {
  dispatch: PropTypes.func,
  searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,MonthWiseClientDeliverable
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MonthWiseClientDeliverable)
)
